import Swiper, {Navigation, Grid} from "swiper"

export default (el) => {
  const swiperEl = el.querySelector('.js-choose-us')

  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 1.4,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 2.4,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  })
}
